"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviousPageButton = exports.NextPageButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("../icons");

var _PaginationButton = _interopRequireDefault(require("./PaginationButton"));

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var PreviousPageButton = function PreviousPageButton(navigationButtonProps) {
  return (0, _core.jsx)(_PaginationButton.default, (0, _extends2.default)({
    dataTestId: "previous-page"
  }, navigationButtonProps), (0, _core.jsx)(_icons.IconChevronLeft, {
    "aria-hidden": true,
    rtl: _icons.IconChevronRight,
    size: navigationButtonProps.paginationVariant === _interfaces.PaginationVariant.Dotted ? _icons.IconSize.ExtraSmall : _icons.IconSize.Small
  }));
};

exports.PreviousPageButton = PreviousPageButton;
PreviousPageButton.displayName = 'PreviousPageButton';

var NextPageButton = function NextPageButton(navigationButtonProps) {
  return (0, _core.jsx)(_PaginationButton.default, (0, _extends2.default)({
    dataTestId: "next-page"
  }, navigationButtonProps), (0, _core.jsx)(_icons.IconChevronRight, {
    "aria-hidden": true,
    rtl: _icons.IconChevronLeft,
    size: navigationButtonProps.paginationVariant === _interfaces.PaginationVariant.Dotted ? _icons.IconSize.ExtraSmall : _icons.IconSize.Small
  }));
};

exports.NextPageButton = NextPageButton;
NextPageButton.displayName = 'NextPageButton';